import React from 'react';
import styled from 'styled-components';
import { primaryColor } from 'js/config/style';

const Container = styled.div`
  align-self: center;
`;

const Display = styled.div`
  background: ${primaryColor.hex()};
  width: 2rem;
  height: 2rem;
  line-height: 2rem;
  border-radius: 3rem;
  font-family: sans-serif;
  text-align: center;
  color: white;
  font-weight: bold;
`;

export default props => (
  <Container>
    <Display>{props.children}</Display>
  </Container>
);
